<template>
    <p-search-screen
        title="Gift Cards"
        api-destination="giftcards"
        edit-key="giftCardId"
        :filters="filters"
        :filterBy="filterBy"
        :fields="fields"
        add-new-button
        ref="search"
    >
         <template v-slot:actionButtons>
                <b-overlay
                    :show="isBusy"
                    rounded
                    opacity="0.5"
                    spinner-small
                    spinner-variant="primary"
                    class="d-inline-block ps-3"
                > 
                    <p-button 
                        variant="outline-primary"
                        type="button"
                        @click="downloadFile"
                        >Export</p-button
                    >
                </b-overlay>
         
        </template>

         <template v-slot:belowSearch>
            <b-row>
                <b-col>
                    <p-checkbox
                        label="Active"
                        v-model="filters.active"
                    />
                    <p-checkbox
                        label="Inactive"
                        class="ms-2"
                        v-model="filters.inactive"
                    />
                </b-col>
            </b-row>
        </template>
    </p-search-screen>
</template>

<script>
import axios from 'axios';
import { dateFormatter, currencyFormatter } from '../../components/Common/Formatters.js';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
import { downloadFileToBrowser } from '@/components/Common/BrowserDownload.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'GiftCardsFilter',
            isBusy: false,
            filters: {
                sortBy: 'cardCode',
                sortDesc: false,
                automatic: "",
                perPage: 100,
                active: true,
                inactive: false,
                searchBy: 'All'
            },
            filterBy: [
                'All',
                'Card Code',
                'Customer Name',
                'Customer Email',
                'Customer Account Number'
            ],
            fields: [
                {
                    key: 'cardCode',
                    label: 'Card Code',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    formatter: (value) => {
                        return value ? 'Active' : 'Inactive';
                    },
                    sortable: true
                },
                {
                    key: 'issueDate',
                    label: 'Issue Date',
                    formatter: dateFormatter,
                    sortable: true
                },
                {
                    key: 'expirationDate',
                    label: 'Expiration Date',
                    formatter: dateFormatter,
                    sortable: true
                },                
                {
                    key: 'balance',
                    label: 'Available Funds',
                    formatter: currencyFormatter,
                    sortByFormatted: true,
                    sortable: true
                },
                {
                    key: 'customerName',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'customerEmail',
                    label: 'Email',
                    sortable: true
                },
                {
                    key: 'customerPhone',
                    label: 'Phone#',
                    sortable: true
                },
                {
                    key: 'comment',
                    label: 'Comment',
                    sortable: true
                }
            ]
        };
    },
    computed: {

    },
    mounted: async function() {
    },
    methods: {
         async downloadFile() {
            let apiUrl = '/giftcards/exportgiftcards'; 
            this.isBusy = true;
            axios
                 .get(apiUrl, { 
                    responseType: 'blob'
                })
                .then(result => {
                    downloadFileToBrowser(
                        result.data,
                        `Gift Card Report`,  
                         'application/pdf'
                          
                    );
                    this.$appSuccess(
                            `Gift Card Report generated successfully.`
                        )
                })
                .finally(() => {
                    this.isBusy = false;
                });
        }
    }
};
</script>

<style scoped lang="scss">
.search-filters {
    margin-bottom: 10px;
}
</style>
